<template>
  <div>
    {{ errorResponse }}
  </div>
  <form @submit.prevent = "register">
  <div class="form-group">
    <input type="text" v-model = "form.name" class="form-control" @blur="validateName" placeholder="Enter Your Name">
    <div>{{ error.name }}</div>
  </div>
  <div class="form-group">
    <input type="email" v-model = "form.email" class="form-control" @blur="validateEmail" placeholder="Enter email">
    <div>{{ error.email }}</div>
  </div>
  <div class="form-group">
    <input type="password" v-model = "form.password" @blur="validatePassword" class="form-control" placeholder="Password">
    <div>{{ error.password }}</div>
  </div>
  <div class="form-group">
    <input type="password" v-model = "form.cpassword" @blur="confirmPassword" class="form-control" placeholder="Confirm password">
    <div>{{ error.cpassword }}</div>
  </div>
 
   <button type="submit" class="btn btn-primary">Submit</button>
</form>
    
</template>

<script setup>

import axios from 'axios';
import {reactive, ref} from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const form = ref({
  name: '',
  email: '',
  password: '',
  cpassword: ''
});

const error = reactive({
  name: '',
  email: '',
  password: '',
  cpassword: ''

});

const errorResponse = ref(null);

function validateName(){
  error.name = '';
  if(!form.value.name){
    error.name = 'Name can not be empty';
  }
}

function validateEmail(){
  error.email = '';
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  error.email = emailPattern.test(form.value.email) ? null : 'Please enter a valid email.';
  
}

function validatePassword(){
  error.password = '';
  error.password = form.value.password.length < 6 ? 'Password must me at 6 characters' : null; 
}

function confirmPassword(){
  error.cpassword = '';

 error.cpassword = form.value.password !== form.value.cpassword ? 'Password did not match': null;
}



async function register(){
  validateName();
  validateEmail();
  validatePassword();
  confirmPassword();
  
  if(error.name || error.email || error.password || error.cpassword ){
    return;
  }

  const data = form.value;

  delete data.cpassword;

  try{
    await  axios.post('api/users/register', data);
    router.push('/login');
    
  }catch(error){
    errorResponse.value = error.response.data.message;

    console.log(error);
  }


}
  


</script>